import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { FarmService } from '.';
import { environment } from '../../../environments/environment';
import { Preference } from '../_models/preference';

@Injectable()
export class JohnDeereService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private farmService: FarmService,
    private http: HttpClient
  ) {}

  // Connect the claas point data provider
  async connectJd() {
    try {
      const currentFarm = await firstValueFrom(this.farmService.getFarmMeFromLocalStore());
      window.open(
        this.telemetryServiceUrl +
          `api/public/oauth/authenticate/jd?farmUUID=${currentFarm.agrirouterUUID}&callback=${window.location.origin}`,
        '_self'
      );
    } catch (e) {
      console.error(e);
    }
  }

  getJohnDeereConnectionUrl(): Observable<string> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/withLeafAuthenticate?externalSource=JOHN_DEERE&redirect_uri=' +
          this.document.baseURI
      )
      .pipe(map((response) => response));
  }

  getImportedFieldsFromJohnDeere(): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/importLeafFields?externalSource=JOHN_DEERE'
      )
      .pipe(map((response) => response));
  }

  getImportedCropsFromJohnDeere(): Observable<any> {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/importLeafCrops?externalSource=JOHN_DEERE'
      )
      .pipe(map((response) => response));
  }

  exportFieldsForJohnDeere(): Observable<any> {
    return this.http
      .post<any>(
        this.telemetryServiceUrl +
          'api/private/v3/machine/exportFieldsToProviders?externalSource=JOHN_DEERE&all=true',
        null
      )
      .pipe(map((response) => response));
  }

  disconnectJohnDeere(): Observable<any> {
    return this.http
      .get(
        this.telemetryServiceUrl +
          'api/private/v3/machine/disconnectProvider?externalSource=JOHN_DEERE'
      )
      .pipe(map((response) => response));
  }

  setPreferenceOnResource(preference: Preference): Observable<any> {
    return this.http
      .post(
        this.telemetryServiceUrl + 'api/private/v3/machine/preference?externalSource=JOHN_DEERE',
        preference
      )
      .pipe(map((response) => response));
  }
}
